import { createContext } from "react";
import type {
  UserListItem,
  CreateUserPayload,
  AssignSubscriptionPayload,
} from "../../../api/auth";

export interface UsersContextType {
  users: UserListItem[];
  loading: boolean;
  error: unknown;
  refetch: () => Promise<void>;
  createUser: (
    payload: CreateUserPayload,
  ) => Promise<{ message: string; userId: string }>;
  assignSubscription: (
    userId: string,
    payload: AssignSubscriptionPayload,
  ) => Promise<void>;
  removeSubscription: (userId: string) => Promise<void>;
  sendCsaPaymentReminder: (
    userId: string,
  ) => Promise<{ message: string; emailSent?: boolean }>;
  promptDeleteUser: (userId: string) => void;
}

export const UsersContext = createContext<UsersContextType>({
  users: [],
  loading: false,
  error: null,
  refetch: () => Promise.reject(new Error("UsersContext not provided")),
  createUser: () => Promise.reject(new Error("UsersContext not provided")),
  assignSubscription: () =>
    Promise.reject(new Error("UsersContext not provided")),
  removeSubscription: () =>
    Promise.reject(new Error("UsersContext not provided")),
  sendCsaPaymentReminder: () =>
    Promise.reject(new Error("UsersContext not provided")),
  promptDeleteUser: () => {},
});
